import { useQuery, type UseQueryResult } from 'react-query';
import {
  WarrantService,
  type Wealthlane_CapTable_Dtos_Warrant_WarrantInstrumentDto,
} from '@wealthlane/api-services/wealthlane-captable-service';

const useGetWarrantById = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  warrantId: string,
  enabled: boolean = true
): UseQueryResult<Wealthlane_CapTable_Dtos_Warrant_WarrantInstrumentDto | undefined, unknown> => {
  return useQuery(
    ['getWarrantById', warrantId],
    async () => {
      return await handleRequest(
        WarrantService.getApiCapTableApiAppWarrant(warrantId)
      );
    },
    { enabled: enabled && !!warrantId }
  );
};

export default useGetWarrantById;
